import { useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useApp } from "../context/AppContext";
import { AuthLayout } from "./Login";

export default function Register() {
  const { me, setMe } = useApp();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", phone: "", password: "", accept_terms: false });
  const [busy, setBusy] = useState(false);
  const next = params.get("next") || "/";
  if (me) return <Navigate to={next} replace />;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.accept_terms) return toast.error("Veuillez accepter les conditions d'utilisation");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", f);
      setMe(data);
      nav(next, { replace: true });
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <AuthLayout title="Créer un compte" subtitle="Gratuit. Moins d'une minute.">
      <form onSubmit={submit} className="space-y-3" data-testid="register-form">
        <div className="grid grid-cols-2 gap-3">
          <label><span className="label">Prénom</span><input className="field" required value={f.first_name} onChange={set("first_name")} data-testid="register-first-name-input" /></label>
          <label><span className="label">Nom</span><input className="field" required value={f.last_name} onChange={set("last_name")} data-testid="register-last-name-input" /></label>
        </div>
        <label className="block"><span className="label">Adresse e-mail</span><input className="field" type="email" required value={f.email} onChange={set("email")} data-testid="register-email-input" /></label>
        <label className="block"><span className="label">Téléphone (facultatif)</span><input className="field" type="tel" value={f.phone} onChange={set("phone")} data-testid="register-phone-input" /></label>
        <label className="block"><span className="label">Mot de passe (8 caractères min.)</span><input className="field" type="password" minLength={8} required value={f.password} onChange={set("password")} data-testid="register-password-input" /></label>
        <label className="flex min-h-[48px] items-start gap-3 rounded-xl bg-slate-50 p-3 text-sm text-slate-600">
          <input type="checkbox" className="mt-0.5 h-5 w-5 accent-[#24616A]" checked={f.accept_terms} onChange={set("accept_terms")} data-testid="register-terms-checkbox" />
          <span>J'accepte les <Link to="/legal" target="_blank" className="font-semibold text-teal-600 underline">conditions d'utilisation et la politique de confidentialité</Link>.</span>
        </label>
        <button className="btn-primary w-full" disabled={busy} data-testid="register-submit-btn">{busy ? "Création…" : "Créer mon compte"}</button>
        <Link to="/login" className="block py-2 text-center text-sm font-semibold text-teal-600">J'ai déjà un compte</Link>
      </form>
    </AuthLayout>
  );
}
